import { IGridColumn } from "@gtmhub/shared/components/grid-filtering-bar";
import { USER_ROLES_VIEWONLY } from "@gtmhub/shared/utils/user-roles";
import { IListColumn, IMetricHistory, ListTypes } from "../models/models";

export const userHasOnlyViewOnlyRole = (roles: string[]): boolean => {
  if (!roles) return false;

  if (roles.length === 1 && roles[0] === USER_ROLES_VIEWONLY) {
    return true;
  }

  return false;
};

export const getLatestSnapshotCustomFieldValue = (fieldName: string, latestSnapshot: IMetricHistory): string | string[] => {
  const custFieldKey = fieldName.split(".").pop();
  return latestSnapshot?.customFields?.[custFieldKey] || "";
};

export const isCustomFieldColumn = (column: IListColumn): boolean => {
  return column.fieldName.startsWith("customFields") || column.fieldName.startsWith("latestSnapshot.customFields");
};

export const projectionWithRequiredColumns = (listType: ListTypes, columns?: IGridColumn[]): IGridColumn[] => {
  return Array.from(new Set([...requiredColumnsPerListType[listType], ...(columns || []).map((c) => c.fieldName)])).map((fieldName) => ({ fieldName }));
};

export const projectionWithoutRequiredColumns = (columns?: IGridColumn[]): IGridColumn[] => {
  return Array.from(new Set([...(columns || []).map((c) => c.fieldName)])).map((fieldName) => ({ fieldName }));
};

const requiredColumnsPerListType: Record<ListTypes, string[]> = {
  Objective: [],
  Task: [],
  "Key Result": ["manualType", "targetOperator", "format"],
  Employee: ["auth0Cache.pcture", "managedTeamIds"],
  Team: ["name", "avatar", "color", "picture", "members", "isActive"],
};
